<template>
  <router-view />
</template>

<script>
export default {
  name: 'Index.vue',
  async created() {
    console.log('main index')

  },
  beforeRouteEnter(to, from, next) {

  }
}
</script>

<style scoped></style>
